import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Ville, Ecole, CodePostal } from '../models/etablissement.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EtablissementService {
    apiUrl = environment.apiUrl;

    ville: Ville[];
    ecole: Ecole;

    constructor(private http: HttpClient) { }

    getVille(code_postal: CodePostal, classe: string): Observable<Ville[]> {
        const params = new HttpParams().set('code_postal', code_postal.toString())
                                    .set('classe', classe ? classe.toString() : '');
        return this.http.get(`${this.apiUrl}/villes`, {params: params}).pipe(
            map((res) => {
                this.ville = res['data'];
                return this.ville;
            }),
        catchError(this.handleError));
    }

    getEcole(ville: Ville, classe: string): Observable<Ecole> {
        const params = new HttpParams().set('ville', ville.toString())
                                    .set('classe', classe ? classe.toString() : '');
        return this.http.get(`${this.apiUrl}/ecoles`, {params: params}).pipe(
            map((res) => {
                this.ecole = res['data'];
                return this.ecole;
            }),
        catchError(this.handleError));
    }
    getLycee(ville): Observable<HttpResponse<[]>> {
        const params = new HttpParams().set('query', "find").set('ville', ville);
        return this.http.get<[]>(`${this.apiUrl}/ecoles`, { observe: 'response', params: params  });
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
